<template>
  <!-- 顶部 -->
  <div class="nav">
    <div class="header">
      <div class="header_left">
        <img
          class="image"
          src="../../../../src/assets/layout/head_ysb@2x.png"
          alt=""
        />
        <span>{{
          userInfo.identityType == 1 ? "买家操作台" : "卖家操作台"
        }}</span>
      </div>
      <div class="header_right">
        <div class="header_right_img" @mouseover="openPopCard" @mouseout="closePopCard">
          <img class="avatar" v-if="userInfo.head" :src="userInfo.head | urlLoad" alt="" />
          <img
            class="avatar"
            v-else
            src="../../../assets/layout/no.png"
            alt=""
          />
          <img
            class="downIcon"
            src="../../../assets/layout/icon_user_down@2x.png"
            alt=""
          />
        </div>
        <span class="time">{{ time }}，欢迎您使用优塑宝操作台</span>
        <div class="card" v-if="popCard" @mouseover="openPopCard" @mouseout="closePopCard">
          <div class="top">
            <div class="photo">
              <img class="avatar" v-if="userInfo.head" :src="userInfo.head | urlLoad" alt="" />
              <img
                class="avatar"
                v-else
                src="../../../assets/layout/no.png"
                alt=""
              />
            </div>

            <div class="message">
              <div class="cardShow">{{ userInfo.memberAccount.loginName }}</div>
              <img
                v-if="userInfo.identityType == 1"
                class="icon_sy_wrz cardShow"
                src="../../../assets/home/icon_sy_wrz@2x.png"
                alt=""
              />
              <img
                v-else
                class="icon_sy_wrz cardShow"
                src="../../../assets/home/icon_sy_ysrz@2x.png"
                alt=""
              />
            </div>
          </div>
          <div class="optionslist cardShow">
            <div @click="jump('./news')">我的消息<span class="news_num" v-if="count">{{count}}</span></div>
            <div @click="jump('./contact')">联系人信息</div>
            <div @click="jump('./setupPassword')">修改密码</div>
            <!-- <div @click="logout">退出登录</div> -->
            <div @click="showloginDialog">退出登录</div>
          </div>
        </div>
      </div>

      <el-dialog
        title="提示"
        :visible.sync="loginDialog"
        width="5.76rem"
        center
        class="del_dialog"
        :modal-append-to-body="false"
      >
        <span>是否退出当前账号</span>
        <span slot="footer" class="dialog-footer">
          <el-button @click="loginDialog = false">取消</el-button>
          <el-button type="primary" @click="logout">确定</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import bus from "../../../utils/bus.js";
export default {
  data() {
    return {
      time: "",
      popCard: false,
      userInfo: {},
      loginDialog: false,
      picture: "",
      timeout: "",
      count: ""
    };
  },
  created() {
    this.getUserInfo();
    this.getNotificationUnread()
    let nowData = new Date();
    let weeks = [
      "星期日",
      "星期一",
      "星期二",
      "星期三",
      "星期四",
      "星期五",
      "星期六",
    ];
    this.time =
      nowData.getFullYear() +
      "年" +
      (nowData.getMonth() + 1) +
      "月" +
      nowData.getDate() +
      "日" +
      weeks[nowData.getDay()];
    let self = this;
    document.onclick = function (e) {
      let filtersList = [
        "header_right_img",
        "optionslist",
        "top",
        "card",
        "avatar",
        "downIcon",
        "cardShow",
      ];
      // console.log("address", e.path[0].className)
      if (!filtersList.includes(e.path[0].className)) {
        self.popCard = false;
      }
    };
  },
  mounted() {
    bus.$on("showNewPicture", (val) => {
      this.picture = JSON.parse(val);
      console.log("aaa", this.picture);
      
    });
  },
  methods: {
    async getNotificationUnread() {
      let res = await this.$apiFun.getNotificationUnread();
      this.count = res.result;
    },

    showloginDialog() {
      this.loginDialog = true;
    },
    openPopCard() {
      clearTimeout(this.timeout)
			this.popCard = true
    },
    closePopCard() {
      this.timeout = setTimeout(()=>{
				this.popCard = false
			},100)
      
    },
    async logout() {
      this.loginDialog = false;
      // let res = await this.$apiFun.logout()
      // if (res.code == 200) {
      this.$message.success("操作成功");
      this.$cookies.set("you_su_bao", "");
      this.$router.replace({ path: "login" });
      this.$cookies.set("isClick",'/home')
      this.popCard = false;
      sessionStorage.setItem("userInfo", "");
      // }else {
      //   this.$message.error("操作失败")
      // }
    },
    jump(url) {
      this.$router.replace(url);
      this.popCard = false;
    },
    async getUserInfo() {
      let res = await this.$apiFun.getUserInfo();
      this.userInfo = res.result;
      this.picture = this.userInfo.head;
      // console.log("this.picture",this.picture);
    },
  },

  // watch: {
  //   "userInfo.head": {
  //     handler(newValue, oldValue) {
  //       console.log("头像监听", newValue, oldValue);
  //     },
  //   },
  // },
};
</script>

<style lang="less" scoped>
/deep/.el-dialog {
  margin-top: 2rem !important;
  border-radius: 10px;
  .el-dialog__header {
    border-radius: 10px 10px 0px 0px;
    background: #efefef;
    display: flex;
    justify-content: space-between;
    .el-dialog__title {
      margin-left: 0.3rem;
      font-size: 0.2rem;
      font-weight: bold;
      color: #333333;
    }
  }
  .el-dialog__footer {
    height: 0.7rem;
    padding: 0;
    .dialog-footer {
      width: 100%;
      height: 0.4rem !important;
      display: flex;
      justify-content: center;

      .el-button--default {
        width: 2rem;
        height: 0.4rem;
        line-height: 0.1rem;
        background: #ffffff;
        border: 1px solid #333333;
        border-radius: 5px;
        display: block;
      }
      .el-button--primary {
        width: 2rem;
        height: 0.4rem;
        line-height: 0.1rem;
        background: #f42551;
        border-radius: 5px;
        border: none;
        margin-left: 0.3rem;
        display: block;
      }
    }
  }
}
.nav {
  width: 100%;
  background: #ffffff;
  z-index: 11;
  position: sticky;
  top: 0;
  .header {
    width: 13.44rem;
    display: flex;
    justify-content: space-between;
    // padding: 14px 15%;
    height: 1rem;
    margin: 0 auto;
    background: #ffffff;
    // box-shadow: 0px 3px 20px 0px rgba(230, 230, 230, 0.8);

    z-index: 2;
    .header_left {
      height: 100%;
      display: flex;
      align-items: center;margin-left: -1rem;
      .image {
        // width: 72px;
        // height: 72px;
        width: 0.72rem;
        height: 0.72rem;
      }
      span {
        margin-left: 0.2rem;
        // font-size: 0.16rem;
        // font-weight: 400;
        // color: #333333;
        line-height: 1rem;

        font-size: 0.24rem;
        font-weight: bold;
        color: #333333;
      }
    }
    .header_right {
      position: relative;
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;left: 1rem;
      .header_right_img {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        margin-bottom: 0.09rem;
        .avatar {
          width: 0.42rem;
          height: 0.42rem;
          margin-right: 0.1rem;
        }
        .downIcon {
          width: 0.24rem;
          height: 0.24rem;
        }
      }
      .time {
        font-size: 0.16rem;
        font-weight: 400;
        color: #666666;
      }
      .card {
        position: absolute;
        z-index: 10;
        padding: 0.2rem 0.1rem;
        box-sizing: border-box;
        width: 3.1rem;
        height: 2.31rem;
        background: #ffffff;
        box-shadow: 2px 2px 10px 0px #cccccc;
        border-radius: 5px;
        top: 0.6rem;
        right: 0px;
        font-size: 0.18rem;
        font-weight: 400;
        color: #333333;
        .top {
          display: flex;
          justify-content: flex-start;
          align-items: center;
          border-bottom: 1px solid #efefef;
          padding-bottom: 0.1rem;
          .photo {
            .avatar {
              width: 0.42rem;
              height: 0.42rem;
            }
          }
          .message {
            margin-left: 0.1rem;
            display: flex;
            flex-direction: column;
            .icon_sy_wrz {
              width: 0.9rem;
              // height: 0.28rem;
            }
          }
        }
        .optionslist {
          // height: 80%;
          height: 1.528rem;
          display: flex;
          flex-direction: column;
          width: 100%;
          justify-content: space-around;
          > div {
            cursor: pointer;
            text-align: left;
            padding-left: 0.6rem;
            box-sizing: border-box;
            width: 1.74rem;
          }
        }
      }
    }

    .del_dialog {
      /deep/.el-dialog {
        .el-dialog__body {
          text-align: center;
          span {
            font-size: 0.2rem;
            font-weight: 400;
            color: #333333;
          }
        }
      }
    }
  }
  
}
.news_num {
    padding: 2px 4px;
    background: #f42551;
    border-radius: 12px;
    font-size: 0.16rem;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #ffffff;
    margin-left: 0.1rem;
  }
img {
  object-fit: cover;
}
</style>